// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { GetEntityAssetsForDpSelector_HoldingsFragment, GetEntityAssetsForDpSelector_OwnershipStakeFragment } from './GetEntityAssetsForDPSelector.generated';
import { gql } from '@apollo/client';
import { GetEntityAssetsForDpSelector_HoldingsFragmentDoc, GetEntityAssetsForDpSelector_OwnershipStakeFragmentDoc } from './GetEntityAssetsForDPSelector.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHouseholdAssetsForCrossEntityDp_BucketFragment = { __typename?: 'EntityHoldingsBucket', entity: { __typename?: 'Entity', id: string, ownedByStakes?: Array<{ __typename?: 'OwnershipStake', id: string }> | null, assetGroups: { __typename?: 'AssetGroupConnection', edges?: Array<{ __typename?: 'AssetGroupEdge', node?: { __typename?: 'AssetGroup', id: string, name: string, integrationKind?: Types.IntegrationExternalKind | null } | null } | null> | null }, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } }, holdings: (
    { __typename?: 'EntityHoldings' }
    & GetEntityAssetsForDpSelector_HoldingsFragment
  ) };

export type GetHouseholdAssetsForCrossEntityDp_GrantorFragment = { __typename?: 'ClientProfile', id: string, displayName: string, ownedOwnershipStakes?: Array<(
    { __typename?: 'OwnershipStake' }
    & GetEntityAssetsForDpSelector_OwnershipStakeFragment
  )> | null };

export type GetHouseholdAssetsForCrossEntityDpQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type GetHouseholdAssetsForCrossEntityDpQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, entityHoldings: Array<(
          { __typename?: 'EntityHoldingsBucket' }
          & GetHouseholdAssetsForCrossEntityDp_BucketFragment
        )>, possiblePrimaryClients: Array<(
          { __typename?: 'ClientProfile' }
          & GetHouseholdAssetsForCrossEntityDp_GrantorFragment
        )> } | null } | null> | null } };

export const Operations = {
  Query: {
    GetHouseholdAssetsForCrossEntityDp: 'GetHouseholdAssetsForCrossEntityDp' as const
  },
  Fragment: {
    GetHouseholdAssetsForCrossEntityDp_Bucket: 'GetHouseholdAssetsForCrossEntityDp_Bucket' as const,
    GetHouseholdAssetsForCrossEntityDp_Grantor: 'GetHouseholdAssetsForCrossEntityDp_Grantor' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GetHouseholdAssetsForCrossEntityDp_BucketFragmentDoc = gql`
    fragment GetHouseholdAssetsForCrossEntityDp_Bucket on EntityHoldingsBucket {
  entity {
    id
    ownedByStakes {
      id
    }
    assetGroups(first: 500) {
      edges {
        node {
          id
          name
          integrationKind
        }
      }
    }
    subtype {
      id
      displayName
    }
  }
  holdings {
    ...GetEntityAssetsForDPSelector_Holdings
  }
}
    ${GetEntityAssetsForDpSelector_HoldingsFragmentDoc}`;
export const GetHouseholdAssetsForCrossEntityDp_GrantorFragmentDoc = gql`
    fragment GetHouseholdAssetsForCrossEntityDp_Grantor on ClientProfile {
  id
  displayName
  ownedOwnershipStakes {
    ...GetEntityAssetsForDPSelector_OwnershipStake
  }
}
    ${GetEntityAssetsForDpSelector_OwnershipStakeFragmentDoc}`;
export const GetHouseholdAssetsForCrossEntityDpDocument = gql`
    query GetHouseholdAssetsForCrossEntityDp($householdId: ID!) {
  households(where: {id: $householdId}) {
    edges {
      node {
        id
        entityHoldings {
          ...GetHouseholdAssetsForCrossEntityDp_Bucket
        }
        possiblePrimaryClients {
          ...GetHouseholdAssetsForCrossEntityDp_Grantor
        }
      }
    }
  }
}
    ${GetHouseholdAssetsForCrossEntityDp_BucketFragmentDoc}
${GetHouseholdAssetsForCrossEntityDp_GrantorFragmentDoc}`;

/**
 * __useGetHouseholdAssetsForCrossEntityDpQuery__
 *
 * To run a query within a React component, call `useGetHouseholdAssetsForCrossEntityDpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHouseholdAssetsForCrossEntityDpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHouseholdAssetsForCrossEntityDpQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useGetHouseholdAssetsForCrossEntityDpQuery(baseOptions: Apollo.QueryHookOptions<GetHouseholdAssetsForCrossEntityDpQuery, GetHouseholdAssetsForCrossEntityDpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHouseholdAssetsForCrossEntityDpQuery, GetHouseholdAssetsForCrossEntityDpQueryVariables>(GetHouseholdAssetsForCrossEntityDpDocument, withFetchPolicyContext(options));
      }
export function useGetHouseholdAssetsForCrossEntityDpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHouseholdAssetsForCrossEntityDpQuery, GetHouseholdAssetsForCrossEntityDpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHouseholdAssetsForCrossEntityDpQuery, GetHouseholdAssetsForCrossEntityDpQueryVariables>(GetHouseholdAssetsForCrossEntityDpDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetHouseholdAssetsForCrossEntityDpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHouseholdAssetsForCrossEntityDpQuery, GetHouseholdAssetsForCrossEntityDpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHouseholdAssetsForCrossEntityDpQuery, GetHouseholdAssetsForCrossEntityDpQueryVariables>(GetHouseholdAssetsForCrossEntityDpDocument, withFetchPolicyContext(options));
        }
export type GetHouseholdAssetsForCrossEntityDpQueryHookResult = ReturnType<typeof useGetHouseholdAssetsForCrossEntityDpQuery>;
export type GetHouseholdAssetsForCrossEntityDpLazyQueryHookResult = ReturnType<typeof useGetHouseholdAssetsForCrossEntityDpLazyQuery>;
export type GetHouseholdAssetsForCrossEntityDpSuspenseQueryHookResult = ReturnType<typeof useGetHouseholdAssetsForCrossEntityDpSuspenseQuery>;
export type GetHouseholdAssetsForCrossEntityDpQueryResult = Apollo.QueryResult<GetHouseholdAssetsForCrossEntityDpQuery, GetHouseholdAssetsForCrossEntityDpQueryVariables>;